import { createSelector } from '@reduxjs/toolkit';
import { Tracking } from '../models/trackings';
import { AppState, trackingSelector } from '../store/store';

export const getTrackingsFromDate = createSelector([
    (state: AppState) => trackingSelector.selectAll(state),
    (state: AppState) => state.admin.trackingFrom,
    (state: AppState) => state.admin.trackingTo,
], (trackings: Tracking[], from: number, to: number) => {
    const f = from.valueOf();
    const t = to.valueOf();
    return trackings.filter(p => p.created >= f && p.created <= t);
}
);

export const filterTrackings = createSelector([
    (state: AppState) => getTrackingsFromDate(state),
    (state: AppState, filter: (p: Tracking) => boolean) => filter
], (trackings: Tracking[], filter: (p: Tracking) => boolean) => {
    console.log('filter', filter);
    console.log('2', filter({} as unknown as Tracking));
    return trackings.filter(filter);
});
